import { BookedTrip } from '@ibe/models';

/**
 * State for a BookedTrip
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	bookedTrip: BookedTrip;
	recoverInsurance: [{ name: string, value: string, price: number }];
	
	promo_vouchers: [{
		code: string;
		type: string;
		amount?: number;
		currencyCode?: string;
		status?: string;
		applyTo?: string;
		amountType?: string;
	}];

	extras: [
		{
			type: string,
			value: Object,
			stopoverCity?: string,
			data?: any,
			stopoverHotel?: boolean
		}
	];
	stopover?: any;
	weakflight_amt: any;
	preOrderEligible: string;
}

export const initialState: State = {
	loading: false,
	bookedTrip: null,
	recoverInsurance: null,
	promo_vouchers: null,
	extras: null,
	stopover: null,
	weakflight_amt: null,
	preOrderEligible: null
};
